import React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { F0Heading, F0Text } from '@factorialco/f0-react'

export interface WizardStepLayoutProps {
  children?: React.ReactNode
  title: string
  subtitle: string
}

export const WizardStepLayout = ({ title, subtitle, children }: WizardStepLayoutProps) => {
  return (
    <Box flexDirection="column" gap="s24" width="full">
      <Box flexDirection="column" gap="s8" style={{ width: '500px' }}>
        <F0Heading variant="heading-large" content={title} />
        <F0Text variant="body" content={subtitle} />
      </Box>
      {children}
    </Box>
  )
}
